import { render, staticRenderFns } from "./app-rating.vue?vue&type=template&id=0129bed1&scoped=true&"
import script from "./app-rating.vue?vue&type=script&lang=js&"
export * from "./app-rating.vue?vue&type=script&lang=js&"
import style0 from "./app-rating.vue?vue&type=style&index=0&id=0129bed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0129bed1",
  null
  
)

export default component.exports